module.exports = __webpack_public_path__ + "media/images/target-210c4e2c6f6cfef3de65e24851b257b4.png";